import React from 'react';
import BlockItem from '../block';
import {useStyle} from './helper'
import {useRouter} from '../../../../../@casino/useRouter';

const GamerItem = ({item}) => {
    const {id, login, balance, air_balance, sum_win, sum_withdrawals, sum_deposit, groups_cashiers, online, replenishment_air_balance} = item;
    const classes = useStyle({online});
    const router = useRouter();

    return (
        <div className={classes.root} onClick={() => router.history.push(`/gamer/view/${id}`)}>
            <span className={classes.online}>{!!online ? 'Online' : 'Offline'}</span>
            <span className={classes.group}>{groups_cashiers}</span>
            <div className={classes.wrapLogin}>
                <span>{login}</span>
            </div>
            <div className={classes.wrapBlock}>
                <div className={classes.w50}>
                    <BlockItem title="Баланс" amount={balance} />
                    <BlockItem title="Сумма пополнений" amount={sum_deposit} />
                    <BlockItem title="Сумма выводов" amount={sum_withdrawals} />
                </div>
                <div className={classes.w50}>
                    <BlockItem title="Воздушный баланс" amount={air_balance} />
                    <BlockItem title="Сумма воздуха" amount={replenishment_air_balance} />
                    <BlockItem title="Сумма выигрышей" amount={sum_win} />
                </div>
            </div>
        </div>
    )
}

export default GamerItem;